import { NavLink, Outlet } from 'react-router-dom';
import { api } from './api';
import { useIdentity } from './context';

const links = [
  ['/', '仪表盘', 'dashboard.read'],
  ['/devices', '设备与授权', 'devices.read'],
  ['/activation-codes', '激活码', 'activation_codes.read'],
  ['/usage', '用量统计', 'usage.read'],
  ['/audit', '审计日志', 'audit.read'],
  ['/administrators', '管理员', '*'],
  ['/settings', '系统设置', 'settings.read']
] as const;

export function Layout() {
  const identity = useIdentity();
  const visible = links.filter(([, , permission]) => identity.permissions.includes('*') || identity.permissions.includes(permission));
  const logout = async () => {
    try { await api('/logout', { method: 'POST' }); } finally { window.location.reload(); }
  };
  return <div className="app-shell">
    <aside className="sidebar">
      <div className="brand"><div className="brand-mark">D</div><div><strong>Dola</strong><span>授权管理后台</span></div></div>
      <nav>{visible.map(([to, label]) => <NavLink key={to} to={to} end={to === '/'}>{label}</NavLink>)}</nav>
      <div className="identity-card"><strong>{identity.displayName || identity.email}</strong><span>{identity.email}</span><span>{identity.role}</span><button className="secondary" onClick={logout}>退出登录</button></div>
    </aside>
    <main className="main-content">
      <div className="topbar"><span>生产环境</span><strong>Dola AI 云授权</strong></div>
      <Outlet />
    </main>
  </div>;
}
